<script>
import ModalAddress from "@/components/profil/address/ModalAddress.vue";
import DrawerUpdateProfil from "@/components/profil/update/DrawerUpdateProfil.vue";
import {api} from "@/modules/api";
import {toast} from "vue3-toastify";

export default {
  name: 'AccountInformations',
  components: {DrawerUpdateProfil, ModalAddress},
  props: {
    profil: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      viewModal: false,
      viewDrawer: false
    }
  },
  computed: {
    addressMain () {
      return this.profil.Address.filter((address) => {
        return address.isMain
      })[0]
    }
  },
  methods: {
    handleResetPassword () {
      api.profil.requestResetPassword({email: this.profil.email}).then(() => {
        toast('Votre demande de mise à jour de mot de passe a été prise en compte, un mail vous a été envoyé !')
      })
    }
  }
}
</script>

<template>
  <div class="flex-1 w-full lg:w-3/4 lg:p-8">
    <h1 class="text-2xl font-bold mb-4 text-primary-700">Vos informations</h1>
    <p class="text-sm text-gray-500 mb-8">
      Gérez vos informations personnelles, y compris les numéros de téléphone et l'adresse e-mail où vous pouvez être contacté.
    </p>
    <div class="grid grid-cols-3 gap-6 mb-5">
      <div v-if="profil.carts" class="p-4 bg-white shadow rounded-lg text-center">
        <h2 class="text-lg font-bold text-gray-500">{{ profil.carts.length }}</h2>
        <p class="text-sm">commandes</p>
      </div>
      <div v-if="profil.Review" class="p-4 bg-white shadow rounded-lg text-center">
        <h2 class="text-lg font-bold text-gray-500">{{ profil.Review.length }}</h2>
        <p class="text-sm ">avis</p>
      </div>
      <div v-if="profil.Favorite" class="p-4 bg-white shadow  text-center rounded-lg">
        <h2 class="text-lg font-bold text-gray-500">{{ profil.Favorite.length }}</h2>
        <p class="text-sm">favoris</p>
      </div>
    </div>
    <div class="flex flex-wrap lg:grid lg:grid-cols-2 gap-6">
      <div class="p-4 w-full bg-white shadow rounded-lg">
        <h2 class="text-sm text-gray-500">Nom</h2>
        <p class="text-lg font-semibold">{{ profil.lastname }} {{ profil.firstname }}</p>
      </div>
      <div class="p-4 w-full bg-white shadow rounded-lg">
        <h2 class="text-sm text-gray-500">Email</h2>
        <p class="text-lg font-semibold">{{ profil.email }}</p>
      </div>
      <div class="p-4 w-full bg-white shadow rounded-lg">
        <h2 class="text-sm text-gray-500">Téléphone</h2>
        <p class="text-lg font-semibold">{{ profil.phone }}</p>
      </div>
      <div class="p-4 w-full bg-white shadow rounded-lg">
        <h2 class="text-sm text-gray-500">
          Votre adresse
          <button @click="viewModal = true" class="text-primary-700 font-medium rounded-lg text-sm px-2">
            <i class="fa-solid fa-plus mr-1"></i>
          </button>
        </h2>
        <p v-if="profil.Address && addressMain" class="text-lg font-semibold">
          {{ addressMain.numberRoute }} {{ addressMain.route }} - {{ addressMain.zipcode }} {{ addressMain.city}}
        </p>
      </div>
    </div>
    <button @click="viewDrawer = true" class=" mt-5 inline-flex w-full items-center justify-center rounded-lg bg-primary-700 px-5 py-2.5 text-sm font-medium text-white hover:bg-primary-800 focus:outline-none focus:ring-4 focus:ring-primary-300 dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800 sm:w-auto">
      <svg class="-ms-0.5 me-1.5 h-4 w-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m14.304 4.844 2.852 2.852M7 7H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-4.5m2.409-9.91a2.017 2.017 0 0 1 0 2.853l-6.844 6.844L8 14l.713-3.565 6.844-6.844a2.015 2.015 0 0 1 2.852 0Z"></path>
      </svg>
      Modifier information
    </button>
    <!-- <button @click="handleResetPassword" class="lg:ml-5 mt-5 inline-flex w-full items-center justify-center rounded-lg bg-gray-300 px-5 py-2.5 text-sm font-medium text-white hover:bg-gray-400 sm:w-auto">
      <svg class="-ms-0.5 me-1.5 h-4 w-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m14.304 4.844 2.852 2.852M7 7H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-4.5m2.409-9.91a2.017 2.017 0 0 1 0 2.853l-6.844 6.844L8 14l.713-3.565 6.844-6.844a2.015 2.015 0 0 1 2.852 0Z"></path>
      </svg>
      Modifier mon mot de passe
    </button> -->
    <drawer-update-profil v-if="viewDrawer" :profil="profil" @close-view="viewDrawer = false" />
    <modal-address v-if="viewModal" @close-modal="viewModal = false" />
  </div>
</template>

